<template>
  <div class="panel-body">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Configuración</a></li>
        <li class="breadcrumb-item active" aria-current="page">Parámetros generales</li>
      </ol>
    </nav>
    <h1 class="regis">Parámetros Generales</h1>
    <hr class="my-4">
    <b-table head-variant="light" striped :per-page="perPagedos" :current-page="currentPage" id="my-table" :items="item"
      :fields="fields">
      <template #cell(valor)="row">
        <b-row>
        <b-col>
          <input type="string" class="form-controll" v-model="row.item.valor" step="10"
            v-bind:style="[row.item.valor != row.item.valorold ? { 'color': ' red' } : { 'color': '#000' }]"
            aria-describedby="basic-addon1">
        </b-col>
        </b-row>
      </template>
      <template #cell(Acciones)="row">
        <b-row class="accionespg">
          <b-col >

            <b-button :disabled="row.item.valor == row.item.valorold" id="tooltip-target-2" variant="success" @click="cambiarPassword(row.item)"><b-icon class="iconobuscar"
                icon="check-circle" /></b-button>

            <b-tooltip target="tooltip-target-2" triggers="hover">

              Guardar

            </b-tooltip>

          </b-col>

          <b-col >

            <b-button :disabled="row.item.valor == row.item.valorold" id="tooltip-target-3" variant="danger" @click="clear(row.item)"><b-icon class="iconobuscar"
                icon="x-circle" /></b-button>

            <b-tooltip target="tooltip-target-3" triggers="hover">

              Borrar

            </b-tooltip>

          </b-col>

        </b-row>
      </template>
    </b-table>
    <b-row>
      <b-col class="nombrelabel" md="2" offset-md="9">
        <label for="selectPage">Registros por página:</label>
      </b-col>
      <b-col md="1">
        <b-form-select class="selectpage" @input="paginacion(currentPage = 1)" v-model="perPage" :options="pageOptions" />
      </b-col>
    </b-row>
    <b-pagination align="center" class="pagpg" @input="paginacion(currentPage)" :total-rows="rows" v-model="currentPage"
      :per-page="perPage">
    </b-pagination>
    <b-alert class="alertared" :show="disiss" dismissible @dismissed="disiss = 0" @dismiss-count-down="disissDownChanged"
      variant="danger">Ingrese un valor para el parámetro.</b-alert>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";
import { getCountries } from 'country-flag-icons'

Vue.use(VueFormGenerator)

const config = RepositoryFactory.get("config");
export default {
  components: {
    "vue-form-generator": VueFormGenerator.component
  },
  data() {
    return {
      fields: ['Nombre', 'Descripción', 'Valor', 'Acciones'],
      pageOptions: [3, 5, 10, 15, 20],
      perPage: 5,
      currentPage: 1,
      orderBy: "nombre",
      typeOrder: "asc",
      dismissSecs: 5,
      dismissCountDown: 0,
      disiss: 0,
      dis: 10,
      modificado: {},
      load: false,
      company: [],
      pp: "",
      mensaje: "",
      item: [],
      totalData: 0,


    }
  },
  computed: {
    rows() {
      return this.totalData;
    }
  },
  mounted() {

  },
  async created() {
    this.parametrosG();


  },
  methods: {

    async parametrosG() {
      try {
        const response = await config.parametrosGenerales({
          "size": this.perPage,
          "page": this.currentPage,
          "orderBy": this.orderBy,
          "typeOrder": this.typeOrder,
        });
        this.totalData = response.count;
        this.item = response.rows.map((x) => {
          var dataa = {
            codigo: x.codigo,
            estado: x.estado,
            fecha_creacion: x.fecha_creacion,
            modulo: x.modulo,
            'Nombre': x.nombre,
            valor: x.valor,
            valorold: x.valor,
            'Descripción': x.descripcion,

          };
          return dataa;
        });


      } catch (error) {

      }
    },
    paginacion(paginacion) {

      this.currentPage = paginacion;
      this.parametrosG();
    },

    clear(event) {

      event.valor = event.valorold;
    },

    validateName(value) {
      const regex = /^[a-zA-Z\s]*$/;
      if (!regex.test(value)) {
        this.model.pnombre = this.model.pnombre.replace(/[^a-zA-Z\s]/g, "");
      }
    },
    async remove(index) {

      this.company = await this.eliminarElementoYInicializar(this.company, index)


    },
    async cambiarPassword(event) {

      if (event.valor == "") {
        this.disiss = this.dis;
      }
      else {
        try {
          const response = await config.updateParametros({
            "codigo": event.codigo,
            "nombre": event.nombre,
            "valor": event.valor,
            "modulo": event.modulo,
            "estado": event.estado,
            "tipo": event.tipocampo
          });
          event.valorold = event.valor
        } catch (error) {
        }
      }
    },
    disissDownChanged(disiss) {
      this.disiss = disiss
    },

    eliminarElementoYInicializar(arr, indice) {
      arr.splice(indice, 1); // Elimina el elemento en el índice especificado

      const nuevoArr = []; // Crea un nuevo objeto vacío

      for (let i = 0; i < arr.length; i++) {
        nuevoArr[i] = arr[i]; // Asigna los elementos del arreglo con las nuevas llaves
      }


      return nuevoArr;
    },
    handleKeypress(event) {
      if (this.identificationType == 'CC' | this.identificationType == 'TI' || this.identificationType == 'NI' || this.identificationType == 'NU') {

        if (e.key.match(/[0-9\s]/i) === null) {
          e.preventDefault();
        }
      } else {
        if (e.key.match(/[a-z0-9\s]/i) === null) {
          e.preventDefault();
        }
      }

    },

  },
}
</script>
<style>
.accionespg{
  margin-left: 16% !important;
}

.pagpg {
  margin-left: -5%;
}

.contenidopg {
  padding-left: 19%;
  padding-top: 2%;
  padding-bottom: 2%;
  border-radius: 7px;
  border: 1px solid gainsboro;
}

.iconopg {
  zoom: 1.5;
  margin-top: -8%;
  margin-right: 5%;
  color: var(--blue-violet);
  cursor: pointer;

}

.iconopgrojo {
  zoom: 1.5;
  margin-top: -8%;
  margin-right: 5%;
  color: var(--alizarin-crimson);
  cursor: pointer;

}

.form-controll {
  display: block;
  width: 100%;
  height: 36px;
  padding-left: 5%;
  margin-top: -5%;
  padding: -0.750rem 0.75rem;
  /* font-size: 1rem; */
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

}

select {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: auto;

}

.fa,
.fas {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
}

.form-group.disabled>label {
  color: #212529 !important;
  font-style: normal !important;
}

/* a continuación hay que poner la instrucción concreta de cada icono. fijaros que en realidad mediante el pseudo-selector ::before introducimos contenido delante de la etiqueta*/

.fa-thumbs-down:before {
  content: "\f165";
}

.nombre {
  transform: uppercase !important;
}

.alertared {
  margin-top: 2%;
}

.dele {
  color: white;
  background: var(--blue-violet);
  border-radius: 5px;
  zoom: 1.8;
  padding: 2%;
}

.hedd {
  font-family: var(--font-family-poppins);
  text-align: left;
  padding: 1%;
}

.dato {
  border-top: 1px solid gainsboro;
}

.contenidotabla {
  background: white;
  margin: 0%;
  border-radius: 8px;
  border: 1px solid gainsboro;
  padding: 1%;
  margin-top: 3%;
}

.tablaa {
  color: #000;
  font-weight: 600;
  text-align: left;
  margin-bottom: 0.01%;
}

.close {
  background: transparent;
  border: none;
  color: white;
  zoom: 1.5;
  margin-top: -0.6%;
  float: right;
}

.alert-dismissible {
  padding-right: 1rem !important;
}

.alert-danger {
  --bs-alert-color: white !important;
  --bs-alert-bg: red !important;
  --bs-alert-border-color: #f5c2c7;
  font-family: var(--font-family-poppins);
  font-size: 14px;
}

.icono {
  zoom: 2;
  margin-left: -32%;
  margin-top: -8%;

}

.vue-form-generator .hint {
  font-style: italic;
  font-size: 10px;
}

.has-error>.fiel-wrap {
  border: 1px solid red;
}

.errors {
  color: red;
  font-size: 11px !important;
}

.panel-body {
  margin: 2% 5%;
  font-family: var(--font-family-poppins);
}

.my-4 {
  color: var(--blue-violet);
}

.regis {
  font-size: 33px !important;
  text-align: center !important;
  font-weight: 600 !important;
  color: var(--blue-violet);
}

.centro {
  text-align: center;
}

hr {
  opacity: 1 !important;
}

.botonregidtro {
  width: 20%;
  margin-top: 2%;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
}

.botonadd {
  width: 50px;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
  position: absolute;
  right: 5%;
  top: 77%;
}</style>